var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#888b8d",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.438 5.1A2.57 2.57 0 0 1 9 2.537h6.5c.654 0 1.296.263 1.798.765l2.474 2.474c.558.438.791 1.119.791 1.824v8.2A2.57 2.57 0 0 1 18 18.362H9A2.57 2.57 0 0 1 6.438 15.8V5.1zM9 3.662c-.789 0-1.437.648-1.437 1.438v10.7c0 .789.648 1.438 1.438 1.438h9c.789 0 1.438-.648 1.438-1.438V7.6c0-.481-.157-.787-.375-.95a.56.56 0 0 1-.06-.052l-2.5-2.5c-.298-.298-.656-.435-1.002-.435H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.438c.311 0 .563.252.563.563v4c0 .172.055.272.11.327s.155.11.327.11h4c.311 0 .563.252.563.563s-.252.563-.562.563h-4c-.428 0-.828-.145-1.123-.44s-.44-.695-.44-1.123V3a.56.56 0 0 1 .563-.562zM6 6.563c-.789 0-1.437.648-1.437 1.438v11c0 .789.648 1.438 1.438 1.438h9c.789 0 1.438-.648 1.438-1.437v-1.3a.56.56 0 0 1 .563-.562c.311 0 .563.252.563.563V19A2.57 2.57 0 0 1 15 21.563H6A2.57 2.57 0 0 1 3.438 19V8A2.57 2.57 0 0 1 6 5.438h1c.311 0 .563.252.563.563s-.252.563-.562.563H6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyStroke);
export default __webpack_public_path__ + "static/media/CopyStroke.2d3fcc15ec73f3f22bfbe157c40c3514.svg";
export { ForwardRef as ReactComponent };